import React from 'react'
import moment from 'moment'
import UserTicketForm from './user-ticket-form.component'
import UserTicketSlider from './user-ticket-slider.component'
import PaginationComponent from './../../../../../components/pagination/pagination.component'
import StyledFlexContainer from './../../../../../components/containers/flex-container.component'
import { connect } from 'react-redux'
import { toastActions } from '../../../../../actions'
import { UserTicketService } from '../../../../../services/user-ticket.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'

const noMarginTopStyle = { marginTop: 0 }

class PointsSolicitationSectionComponent extends React.Component {
	constructor(props) {
		super(props)
		this.onSubmit = onSubmit.bind(this)
		this.paginationRenderRow = paginationRenderRow.bind(this)
	}

	componentDidMount() {
		this.refs.pagination.reload()
	}

	render() {
		return (
			<div>
				<StyledFlexContainer
					alignItems="flex-start"
					style={noMarginTopStyle}>
					<UserTicketForm
						className="col-6"
						style={noMarginTopStyle}
						onSubmit={this.onSubmit}
					/>
					<UserTicketSlider style={noMarginTopStyle} className="col-6" />
				</StyledFlexContainer>
				<p style={{marginTop: 10}}>
					<span className="bold">Acumule sempre e viaje mais!</span>
					{textExplanation}
				</p>
				<PaginationComponent
					loadonce
					rowsPerPage={10}
					ref="pagination"
					title="Minhas solicitações"
					headers={paginationHeaders}
					sortable={paginationSortable}
					renderRow={this.paginationRenderRow}
					getData={UserTicketService.getTickets}
					emptyDatasetText="Nenhum resultado para ser exibido."
				/>
			</div>
		)
	}
}

function onSubmit(
	{ busSeat, ticketNumber, ticketSequence, tripDate, acceptTerms },
	{ setFieldValue, setTouched }
) {
	const { toastSuccess, showLoading, hideLoading, toastWarning } = this.props

	if (!acceptTerms) {
		toastWarning({ message: 'Informe que está ciente das condições' })
		return
	}

	const momentTripDate = moment(tripDate, 'YYYY-MM-DD')

	const momentMinDate = moment().subtract(31, 'days')

	if (momentTripDate.isBefore(momentMinDate)) {
		toastWarning({
			message:
				'O período máximo para solicitação de pontos é de 30 dias a contar da data de embarque.'
		})
		return
	}

	showLoading()

	UserTicketService.registerTicket({
		busSeat,
		tripDate,
		ticketNumber,
		ticketSequence
	}).then(({ success }) => {
		hideLoading()
		if (success) {
			toastSuccess({ message: 'Solicitação realizada com sucesso' })
			this.refs.pagination.reload()
			setTouched({
				busSeat: false,
				partner: false,
				tripDate: false,
				ticketNumber: false,
				ticketSequence: false
			})
			setFieldValue('busSeat', '')
			setFieldValue('ticketNumber', '')
			setFieldValue('ticketSequence', '')
		}
	})
}

function paginationRenderRow(rowData, headers) {
	const buildTicketNumber = ({ ticketNumber, ticketSequence }) =>
		ticketSequence ? `${ticketSequence}-${ticketNumber}` : ticketNumber

	return headers.map(({ key }) => {
		const isDate = ['creationDate', 'tripDate'].includes(key)
		const isTicketNumber = ['ticketNumber'].includes(key)
		const cellData = isDate
			? moment(rowData[key]).format('DD/MM/YYYY')
			: isTicketNumber
			? buildTicketNumber(rowData)
			: rowData[key]

		return (
			<td key={key} style={{ textAlign: 'center' }}>
				<span title={cellData}>{cellData}</span>
			</td>
		)
	})
}

const textExplanation = `
	As solicitações de pontos devem ser feitas para passagens compradas
	nos guichês das rodoviárias do RS e todas as demais rodoviárias
	INTERESTADUAIS, caso alguma passagem não tenha sido pontuado
	automaticamente. O prazo para esta solicitação é de até 30 dias a
	contar data do embarque. Os pontos retroativos serão creditados na
	conta do solicitante em até 10 dias após a data de viagem, e
	provados pelas regras de integridade do Programa. Lembramos que os
	pontos MUVIFLEX serão creditados apenas aos passageiros viajantes e
	detentores dos bilhetes de embarque. O bilhete de embarque é único,
	de sua responsabilidade e intransferível. Mantenha-o sempre seguro e
	aos seus cuidados para poder solicitar seus pontos.
`

const paginationHeaders = [
	{ header: 'Data solicitação', key: 'creationDate', align: 'center' },
	{ header: 'Parceiro', key: 'partner', align: 'center' },
	{ header: 'Bilhete', key: 'ticketNumber', align: 'center' },
	{ header: 'Poltrona', key: 'busSeat', align: 'center' },
	{ header: 'Data Viagem', key: 'tripDate', align: 'center' },
	{ header: 'Situação', key: 'status', align: 'center' }
]

const paginationSortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'creationDate' },
		{ key: 'ticketNumber' },
		{ key: 'busSeat' },
		{ key: 'tripDate' },
		{ key: 'status' }
	]
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastSuccess: toastActions.success,
			toastWarning: toastActions.warning,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const PointsSolicitationSection = connect(
	null,
	mapDispatchToProps
)(PointsSolicitationSectionComponent)

export default PointsSolicitationSection
